// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__g9Ie-","rightAdornment":"Header_rightAdornment__3befs"};